import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const RfpPageTitle = ({ className, text }) => (_jsx("div", Object.assign({ className: `rfp_page_title ${className}` }, { children: _jsx("h2", { children: _jsx("span", { children: text }) }) })));
RfpPageTitle.propTypes = {
    className: propStr(),
    text: propStr().isRequired,
};
RfpPageTitle.defaultProps = {
    className: '',
};
export default RfpPageTitle;
